<div class="card"  (click)="viewRowDetails(currentLid.CustomerId,currentLid)">
    <div *ngFor="let col of columns" >
        <div class="title-value">{{col.headerTranslate |translate}} </div>
        <div class="field-value" *ngIf="!col.type">{{currentLid[col.field]}}</div>
        <div class="field-value" *ngIf="col.type">{{currentLid[col.field] | date:'dd/MM/yyyy'}}</div>
    </div>
</div>